export default "__VITE_ASSET__sVGf_WoC__"